export default function Heading() {
  return (
    <div className='flex flex-col mt-3'>
      <span className='text-status-text-out-of-form text-[22px] leading-1'>Get a tax-efficient plan to</span>
      <span className='text-status-text-out-of-form text-[22px] font-medium leading-[1.2]'>switch to Direct funds</span>
    </div>
  )
}
